import Guard from '@/services/middleware'

const IntegrationsHome = () => import('@/views/dash/settings/integrations/Home.vue')
const IntegrationsServers = () => import('@/views/dash/settings/integrations/Servers.vue')
const IntegrationsServersManager = () => import('@/views/dash/settings/integrations/ServersManager.vue')
const IntegrationsServerDebug = () => import('@/views/dash/settings/integrations/ServerDebug.vue')
const IntegrationAutoSave = () => import('@/views/dash/settings/integrations/AutoSave.vue')
const IntegrationsServerOccurrence = () => import('@/views/dash/settings/integrations/ServersOccurrence.vue')
const TelephonyEdit = () => import('@/views/dash/settings/integrations/TelephonyEdit.vue')

export default [
    {
        path: '/integracoes',
        name: 'integrations.home',
        component: IntegrationsHome,
        meta: { title: 'Integrações', permission: 2, module: 'mod_integration' },
        beforeEnter: [
            Guard.redirectIfNotAuthenticated,
            Guard.checkModuleAccess,
        ],
    },
    {
        path: '/integracoes/telefonia/:id',
        name: 'integrations.telephony.edit',
        component: TelephonyEdit,
        meta: { title: 'Editar Integração de Telefonia', permission: 2, module: 'mod_integration' },
        beforeEnter: [
            Guard.redirectIfNotAuthenticated,
            Guard.checkModuleAccess,
        ],
    },
    {
        path: '/integracoes/:id',
        name: 'integrations.servers',
        component: IntegrationsServers,
        meta: { title: 'Integração', permission: 2, module: 'mod_integration' },
        beforeEnter: [
            Guard.redirectIfNotAuthenticated,
            Guard.checkModuleAccess,
        ],
    },
    {
        path: '/integracoes/:id/auto-identificacao',
        name: 'integrations.servers.autosave',
        component: IntegrationAutoSave,
        meta: { title: 'Auto identificação', permission: 2, module: 'mod_integration' },
        beforeEnter: [
            Guard.redirectIfNotAuthenticated,
            Guard.checkModuleAccess,
        ],
    },
    {
        path: '/integracoes/:id/:server',
        name: 'integrations.servers.manager',
        component: IntegrationsServersManager,
        meta: { title: 'Gerenciar integração', permission: 2, module: 'mod_integration' },
        beforeEnter: [
            Guard.redirectIfNotAuthenticated,
            Guard.checkModuleAccess,
        ],
    },
    {
        path: '/integracoes/:id/:server/debugar',
        name: 'integrations.servers.debug',
        component: IntegrationsServerDebug,
        meta: { title: 'Testar integração', permission: 2, module: 'mod_integration' },
        beforeEnter: [
            Guard.redirectIfNotAuthenticated,
            Guard.checkModuleAccess,
        ],
    },
    {
        path: '/integracoes/:id/:server/ocorrencias',
        name: 'integrations.servers.occurrences',
        component: IntegrationsServerOccurrence,
        meta: { title: 'Configurar Ocorrências', permission: 2, module: 'mod_integration' },
        beforeEnter: [
            Guard.redirectIfNotAuthenticated,
            Guard.checkModuleAccess,
        ],
    },
]